import moment from '@/moment-gp'
import TaskManagementMixin from "@/components/Mixins/TaskManagement"
import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [ TaskManagementMixin ],
  props: {
    name: {
      type: String,
      required: false,
    },
    itemId: {
      type: String,
      required: false
    },
    magicTimeslots: {
      type: Array
    },
    type: {
      type: String,
      default: "all",
    },
    tscColor: {
      type: String,
      default: "",
    },
    config: {
      type: Object,
    },
    hideIfNotPlanned: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // ...mapGetters("optimizer", ["optimizer_result_data"]),
    ...mapGetters("optimizer", [
      'optimizer_result_data'
    ]),
    ...mapGetters("dayplanner", [
      // "dayplan_remaining_timeslots",
      "dayplanner_planned_time_overall_by_commitment",
      "dayplan_from_db_at_selected_day",
      "view_selected_date_as_yymmdd",
      "view_selected_date_as_timestamp",
      'drag_target_dayplan',
      'dayplan_from_db_at_date',
      'drag_target_space',
      'drag_item_placement',
      'drag_item',
      'draggables_list_at_date'
    ]),

    goalId() {
      if (this.config.goalId) {
        return this.config.goalId;
      }
      return null
    },
    commitmentId() {
      if (this.config.commitmentId) {
        return this.config.commitmentId
      }
      return null
    },
    goal_meta() {
      if (this.$models.goalMeta.getNode( this.goalId )) {
        return this.$models.goalMeta.getNode( this.goalId )
      }
      return null
    },
    commitment() {
      if (this.goalId && this.commitmentId) {
        return this.$models.commitment
          .with({ goalId: this.goalId })
          .subscribeNode(this.commitmentId);
      }
      return null
    },
    hide_item() {
      if ( this.hideIfNotPlanned ) {
        if ( this.commitment.type === 'TASKLIST'
          || this.commitment.type === 'TIME_BASED_TASKLIST' ) {

          if ( !this.commitmentDailySettings.committedTimeDaily ) {
            return true;
          }
        }
      }
      return false;
    },
    goal_duration_today() {
      if (this.commitmentDailySettings) {
        return ( this.commitmentDailySettings.committedTimeDaily !== undefined &&
                !isNaN(this.commitmentDailySettings.committedTimeDaily) )
                ? this.commitmentDailySettings.committedTimeDaily
                : this.commitment.committedTimePerDay
      } else {
        return 0
      }
    },
    progress_status() {
      //if (this.session_duration_today >= this.goal_duration_today && !this.goal_duration_today === 0) {
      if (this.progress_percentage && this.progress_percentage >= 100) {
        return 'success'
      } else {
        return null
      }
    },
    progress_percentage() {
      if (!isNaN(this.session_duration_today)) {
        if (this.commitmentDailySettings.committedTimeDaily && !isNaN(this.commitmentDailySettings.committedTimeDaily)) {
          return Math.round(this.session_duration_today / this.commitmentDailySettings.committedTimeDaily * 100 )
        } else if (this.commitment.committedTimePerDay && !isNaN(this.commitment.committedTimePerDay)) {
          return Math.round(this.session_duration_today / this.commitment.committedTimePerDay * 100 )
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    session_duration_today() {
      //console.log('session_duration_today', this.dayplan_from_db_at_date(this.view_selected_date_as_yymmdd), this.view_selected_date_as_timestamp)
      let dayplan = this.dayplan_from_db_at_date(this.view_selected_date_as_yymmdd).filter(session => session.type === 'TASKLIST' && session.config.commitmentId === this.commitmentId)
      let duration = 0
      if (dayplan) {
        dayplan.forEach(session => {
          duration +=
            Math.min(this.view_selected_date_as_timestamp + 86400, session.to) - session.from;
        });
        return duration;
      } else {
        return 0;
      }
    },
    overallTimePlanned() {
      return this.dayplanner_planned_time_overall_by_commitment[ this.commitmentId ] || 0;
    },
    overallProgressPercentage() {
      if (isNaN(this.overallTimePlanned)) {
        return 0;
      }
      let committedTime = this.commitment.committedTime;
      let percentage = Math.round((this.overallTimePlanned / committedTime) * 100 )

      return Math.min( percentage, 100 );
    },
    commitmentDailySettings() {
      //console.log('loading commitmentDailySettings for view_selected_date_as_timestamp', this.view_selected_date_as_timestamp)
      let commitmentDailySettings = this.$models.commitmentDailySettingsItem
        .with({
          goalId: this.goalId,
          dateString: this.view_selected_date_as_yymmdd
        })
        .subscribeNode(this.commitmentId);

      // getData could return an empty object, if data is not present in state

      return commitmentDailySettings;
    },
    imageStyle() {
      if ( !this.commitment.$ready || !this.commitment.picture ) {
        return {}
      }
      return {
        backgroundImage: 'url(' + this.commitment.picture + ')',
        backgroundSize: 'cover'
        // borderColor: this.tscColor,
      }
    },
  },
  methods: {
    ...mapActions('dayplanner', [
      'dayplanFindTimeslot',
      'setDragTargetDate',
      'setDragTargetIndex',
      'setDragItem',
      'setDragItemType',
      'setDragTimeActive',
      'setDragTimeSelection',
      'setBacklogStatus',
    ]),

    onMouseoverAddItem(type, itemPlacementConfig = null) {
      if (!itemPlacementConfig || this.drag_item) {
        return
      }
      //console.log('onMouseoverAddItem type', type)
      //let dayplan = this.drag_target_dayplan || this.dayplan_from_db_at_date(this.view_selected_date_as_yymmdd)
      let dayplan = this.draggables_list_at_date(this.view_selected_date_as_yymmdd)
      if (this.view_selected_date_as_yymmdd && dayplan) {
        this.setDragTargetDate(this.view_selected_date_as_yymmdd,'onMouseoverAddItem')

        let item = {
          type: type,
          dragConfig: itemPlacementConfig
        }
        //console.log('setDragItem', item, dayplan)
        this.setDragItem(item)
        this.setDragTargetIndex(dayplan.length - 1)
        this.setDragItemType('SESSION') // TODO: -> TASKLIST ???
      }
    },

    onMouseleaveAddItem() {
      this.setDragItem(null)
      this.setDragItemType(null)
      //this.setDragTimeSelection(null)
      //this.setDragTimeActive(false)
    },

    // TODO: Move to mixin - or vuex?
    async onAddItem({ type = 'TASKLIST', tasks = null, sequenceItems = null }) {
      //console.log('onAddItem', this.drag_item_placement, tasks, sequenceItems)
      //console.log('onAddItem()',this.itemId, duration, this.drag_target_space.maxToWithShifting - this.drag_target_space.minFromWithShifting >= duration, this.drag_target_space.maxToWithShifting, this.drag_target_space.minFromWithShifting, remainingDuration)

      if (!this.drag_item_placement) {
        return
      }

      let duration = this.drag_item_placement.to - this.drag_item_placement.from
      //console.log('onAddItem', duration)
      if (duration <= 0) {
        this.onMouseleaveAddItem()
        return
      }

      this.$models.userDayplannerSessions.add({
        dateString:    this.view_selected_date_as_yymmdd,
        from:          this.drag_item_placement.from,
        to:            this.drag_item_placement.to,
        type:          type,
        commitmentId:  this.commitmentId,
        sortidx:       this.drag_target_space.sortidx,
        createdAt:     moment.currentTime().unix()
      }).then(sessionId => {

        // Show backlog
        this.setBacklogStatus({ sessionId, status: true });

        if ( sequenceItems === null ) {
          return
        }

        //console.log('onAddItem new sessionId', sessionId)
        sequenceItems.forEach(sequenceItem => {
          this.$api.task_create_user({
            goal_id:   this.goalId,
            parent_id: this.commitmentId,
            member_id: this.$models.user.defaultUserId,
            data: {
              sortidx: 1, // HACK !!! get_last_sortidx, won't work
              name: sequenceItem.cachedTitle,
              sessionId: sessionId,
              durationRemaining: sequenceItem.duration
            }
          }).then((taskId) => {
            //console.log('onAddItem new taskId', taskId)
            this.onAddTaskToSession({
              goalId: this.goalId,
              memberId: this.$models.user.defaultUserId,
              taskId: taskId,
              tasksInSession: [],
              sessionId: sessionId,
            });
          });
        })
      })

      this.onMouseleaveAddItem()
    },

    onChangeCommittedTimePerDay(committedTimePerDay) {
      this.$models.commitment
        .with({ goalId: this.goalId })
        .update(this.commitment.$id, {
          committedTimePerDay: committedTimePerDay
        });
    },

    onChangeCommittedTimeDailyForDateTimestamp(committedTimeDaily) {
      console.log(
        "onChangeCommittedTimeDailyForDateTimestamp",
        this.goalId,
        this.commitmentId,
        this.view_selected_date_as_timestamp,
        committedTimeDaily
      );
      return this.$models.commitmentDailySettingsItem
        .with({
          goalId: this.goalId,
          dateString: this.view_selected_date_as_yymmdd
        })
        .update(this.commitmentId, {
          committedTimeDaily: committedTimeDaily
        });
    },

  getSequenceTasks(commitmentId, date_as_yymmdd) {
    let suggestion = null
    if (
      this.optimizer_result_data["dayplan_suggestions"] &&
      this.optimizer_result_data["dayplan_suggestions"][date_as_yymmdd] &&
      this.optimizer_result_data["dayplan_suggestions"][date_as_yymmdd][commitmentId]
    ) {
      suggestion = this.optimizer_result_data["dayplan_suggestions"][date_as_yymmdd][commitmentId];
    }
    if (suggestion) {
      let tasks = null
      if (suggestion.tasks) {
        tasks = []
        suggestion.tasks.forEach(taskData => {
          console.log('taskData', taskData)
          let task = {
            taskId: 'test', //taskData.$id,
            from: 1234567890, // TODO: change
            duration: taskData.duration,
            cachedTitle: taskData.title + ' - day ' + suggestion.day,
            cachedFinishedAt: null,
            sequenceItemId: taskData.sequenceItemId,
            sequenceRound: taskData.sequenceRound,
        };
        tasks.push(task)
        })
      }
      //console.log('sequenceTasks', tasks)
      return tasks
    }
    return null
  },

    /*removeCommitmentDailySetting() {
      this.$models.commitmentDailySettingsItem
        .with({
          goalId: this.goalId,
          dateString: this.view_selected_date_as_yymmdd
        })
        .remove(this.commitmentId);
    },*/
  },
}
